export default __webpack_public_path__ + "static/media/ListOfReceiptReport.b66c1d79.svg";